export const getToken = JSON.parse(localStorage?.getItem("Content"))?.Token;
let apiUrl = "http://162.0.222.125:8002";

export const serviceCall = async (method, getUrl, getData) => {
  document.getElementById("showSpinner") && document.getElementById("showSpinner").removeAttribute("hidden");
  let commonHeaders = {
    "Content-Type": "application/json",
    "accept": "application/json",
    ...(getToken &&  !getUrl.includes("/Account") ? { "authorization": `Bearer ${getToken}` } : "")
  };
  const options = {
    method: method,
    headers: commonHeaders,
    ...(method !== "GET" ? { "body": JSON.stringify(getData) } : "")
  };
  let url = apiUrl + getUrl;
  return await fetch(url, options).then((response) => {
    if (response.ok || response.status === 400 || response.status === 204) {
      document.getElementById("showSpinner") && document.getElementById("showSpinner").setAttribute("hidden", "true");
      return response.json();
    }
    throw response;
  }).then((response) => {
    return response;
  }).catch((error) => {
    console.log("Error in Service Call");
    document.getElementById("showSpinner") && document.getElementById("showSpinner").setAttribute("hidden", "true");
    if(getToken && !getUrl.includes("EmptyCart")) {
      window.localStorage.clear();
      window.location.reload();
    }
  })
};


export const CustomEvent = (event, params) => {
  params = params || {bubbles: false, cancelable: false, detail: null};
  var evt = document.createEvent("CustomEvent");
  evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
  return evt;
}